import { ProductBundleState } from 'src/store/productBundle/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { Price } from 'src/store/price/types';

const setProductBundleSelectedProductsTotalPriceReducer = (state: ProductBundleState, action: PayloadAction<Price>) => {
  state.selectedProductsTotalPrice = action.payload;
};

export default setProductBundleSelectedProductsTotalPriceReducer;
